import API from './api';
import SignInComponents from './components';
import { WebAuthn } from '../shared/Authentication';

export default {
  authenticateWithWebauthn: (event) => {
    event?.preventDefault();

    if (WebAuthn.supported()) {
      API.webauthnOptions().then(({ data }) => {
        WebAuthn.get(data).then((credential) => {
          const params = {
            user: {
              credential: credential.toJSON(),
              ...(SignInComponents.rememberDeviceCheckbox() && {
                remember_on_device: SignInComponents.rememberDeviceCheckbox().checked
              })
            }
          };

          API.signIn(params).then(() => {
            window.location.replace('/');
          });
        }).catch(() => {
          /*
            Currently, we don't handle the case when a user closes the browser
            authentication window.
          */
        });
      });
    }
  },
  checkNextStep: (onSuccess) => () => {
    const email = SignInComponents.emailOnSignInForm().value;

    API.sessionStatus({ email }).then((response) => {
      if (response.data) {
        onSuccess();
      }
    });
  },
  /*
    Used to disable WebAuthn form when a browser doesn't support the feature
  */
  disableWebauthn: () => {
    const alert = document.createElement('div');
    alert.classList.add('alert', 'alert-warning');
    alert.textContent = "Sorry, your browser doesn't support authentication with security keys";

    const submitButton = SignInComponents.webauthnForm().querySelector('[type=submit]');
    submitButton.disabled = true;

    SignInComponents.webauthnForm().insertBefore(
      alert,
      submitButton.parentElement
    );
  },
  /*
    Used for toggling MFA forms when a user has both passkey and authenticator
    app set up
  */
  replaceAuthenticationForm: (currentForm, newForm) => (event) => {
    event.preventDefault();

    SignInComponents[currentForm]().classList.add('d-none');
    SignInComponents[newForm]().classList.remove('d-none');
  }
};
